import { observable } from 'mobx';
// import { useRequest } from 'ahooks';
// import Service from './service';
import { autobind } from 'core-decorators';
import { useEffect } from 'react';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import DateUtil from '@src/utils/date-util';
import { jumpPage, aLink } from '@src/utils/common-util';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

// import routeConfigs from '@src/pages/app-router/route-configs';
// import { delay } from '@src/utils/common-util';
// import AntdMessage from '@src/components/antd/message';
// import { $$tracker } from '@src/tracker';

class NewsDetailsStore extends BaseStore {
  @observable isLoading = false;
  /**
   * 文章内容
   * @type {string}
   */
  @observable content;
  /**
   * 标题
   * @type {string}
   */
  @observable title;
  /**
   * 返回按钮
   * @type {string}
   */
  @observable btnIcon;
  /**
   * 创建时间
   * @type {string}
   */
  @observable createTimestamp;

  tabName = {
    new: '最新',
    news: '新闻',
    gonggao: '公告',
    activity: '活动',
    strategy: '攻略'
  };

  @observable tab_key;
  get createDate() {
    if (!this.createTimestamp) {
      return '';
    }
    return DateUtil.formatDate(new Date(this.createTimestamp * 1000), 'yyyy/MM/dd');
  }
  Lang() {
    if (getLanguageByPath() === 'zh-Hant') {
      return 'tc';
    } else {
      return getLanguageByPath();
    }
  }

  goBack() {
    // IS_DEV_ENV  DEPLOY_ENV
    if (!IS_DEV_ENV) {
      const url = 'news-list.html';
      jumpPage(url, '#/');
    } else {
      this.redirect('/news-list');
    }
  }

  @autobind
  onBackBtnClick() {
    // this.redirect(routeConfigs.NEWSLIST.getFormatPath());
    // this.backRedirect();
  }

  /**
   * 获取文章详细信息
   * @param {string} contentId - 文章ID
   */
  getArticleDetail = async contentId => {
    const res = await window.FUN_LINK_SDK.getLayersData([{ layerId: 'article_detail', type: 'content', param: { contentId } }]);
    const article_detail = res?.data?.article_detail;
    const data = await window.__FUN_LINK_PAGE_DATA_PROMISE__;
    //console.log(' DownloadStore   article_detail:', article_detail, data);
    if (!article_detail) {
      console.error('文章详情数据获取失败', res);
      return;
    }
    if (article_detail.url) {
      aLink(article_detail.url, '_self');
      return;
    }

    this.tab_key = article_detail.tab_key;
    /**
     * 设置文章标题
     * @param {string} title - 文章标题
     */
    this.title = article_detail.title;
    // /**
    //  * 设置btnIcon
    //  * @param {string} btn - btnIcon
    //  */
    // this.btnIcon = data.data.article_info.back_btn;
    /**
     * 设置文章内容
     * @param {string} content - 文章内容
     */
    this.content = article_detail.content;
    /**
     * 设置文章日期
     * @param {number} date - 文章日期
     */
    this.createTimestamp = article_detail.publishedAt;
  };

  use() {
    super.use();

    // const data = useFunLinkPageData();

    // useEffect(
    //   () => {
    //     if (!data) {
    //       return;
    //     }
    //     //console.log('data', data);
    //     this.content = data.article_detail.content;
    //     this.title = data.article_detail.title;
    //     this.createTimestamp = data.article_detail.date;
    //   },
    //   [data]
    // );
    // this.getArticleRequest = useRequest(async params => await Service.getArticleAsync(params), {
    //   manual: true,
    //   throwOnError: true
    // });
    useMount(() => {
      const contentId = this.$routeMatch.query.contentId;
      //console.log('contentId', contentId, this.$routeMatch);

      if (contentId) {
        //console.log(1111111111111111);

        this.getArticleDetail(contentId);
      } else {
        console.error('未提供contentId参数', window.location.search);
      }
    });
    useEffect(() => { }, []);
  }
}

export default NewsDetailsStore;
